import * as React from "react";

const PlusIcon = (props: any) => (
  <svg
    className={props.className}
    width="32"
    height="31"
    viewBox="0 0 32 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_150_6499"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="31"
    >
      <rect width="32" height="30.8571" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_150_6499)">
      <path
        d="M14.668 16.7144H6.66797V14.143H14.668V6.42871H17.3346V14.143H25.3346V16.7144H17.3346V24.4287H14.668V16.7144Z"
        fill="#9A6C43"
      />
    </g>
  </svg>
);

export default PlusIcon;
